/*** IMPORTS FROM imports-loader ***/
var global = window;

var makeString = require('./helper/makeString');

module.exports = function isBlank(str) {
  return (/^\s*$/).test(makeString(str));
};

